<template>
    
<app-modal v-on:close="$emit('close')" :title="page.vacancy_apply_title" :description="page.vacancy_apply_description">

    <template v-slot:default>

        <app-group :slim="true">

            <app-input-text :slim="true" :label="page.vacancy_apply_name_label" v-model="inputs.name" :errored="errored.name" :placeholder="page.vacancy_apply_name_placeholder" />
            <app-input-text :slim="true" :label="page.vacancy_apply_email_label" v-model="inputs.email" :errored="errored.email" :placeholder="page.vacancy_apply_email_placeholder" />
            <app-input-check v-if="loggedin && session.cv" :slim="true" label="Use your previously uploaded CV?" v-model="inputs.use" :errored="errored.use" />
            <app-input-file v-if="!inputs.use" :slim="true" :label="page.vacancy_apply_file_label" v-model="inputs.file" :errored="errored.file" v-on:change="inputs.fileRaw = arguments[0]" :placeholder="page.vacancy_apply_file_placeholder" />
            <app-input-check v-if="loggedin && !inputs.use" :slim="true" :label="page.vacancy_apply_save_label" v-model="inputs.save" :errored="errored.save" :placeholder="page.vacancy_apply_save_placeholder" />
           
			<app-message v-if="is.saved" :success="true">Application successfully submitted.</app-message>

        </app-group>

    </template>

    <template v-slot:foot>

		<app-button :text="page.vacancy_apply_button_save" :success="is.saved" :disabled="!is.valid || is.saved" :loading="is.submitting" v-on:click="onSaveClick" />
		<app-button :text="page.vacancy_apply_button_cancel" :disabled="is.submitting" v-on:click="$emit('close')" />

    </template>

</app-modal>

</template>

<script>

import mixinForm from '@/mixin/form.js'
import mixinModal from '@/mixin/modal.js'

export default {

    mixins: [mixinForm, mixinModal],
    
	data: function() {

		return { 
			inputs: {
                name: '',
                email: '',
                file: '',
                fileRaw: '',
				use: 0,
				save: 0
			},
			rules: {
				name: {
					required: true
                },
                email: {
                    required: true
                }
			}
		}

	},

	created: function() {

		if (this.loggedin) {
			
			this.inputs.name = this.session['firstname'] + ' ' + this.session['lastname']
			this.inputs.email = this.session['email']
			this.inputs.use = (this.session.cv) ? 1 : 0

		}

	},

	methods: {
        
		onSaveClick: function() {

			this.save('vacancy/apply', {
                inputs: this.inputs,
                vacancy: this.params.vacancy
            }).then(function() {

                this.processEvents()
            
                this.is.saved = true
				this.is.submitting = false

            }.bind(this))

		}

	}
    
}

</script>